// I Pops: gli avatar degli agenti, 5 varianti per ruolo (`web/public/pops`). Lo stesso elenco
// sta in `poptown/missions/roles.py`, che controlla l'avatar quando si salva un pop.
export const POP_ROLES: { id: string; label: string }[] = [
  { id: 'team-lead', label: 'Team leader' },
  { id: 'project-manager', label: 'Project manager' },
  { id: 'developer', label: 'Developer' },
  { id: 'reviewer', label: 'Reviewer' },
  { id: 'qa', label: 'QA' },
  { id: 'researcher', label: 'Ricercatore web e database' },
  { id: 'analyst', label: 'Analista del codice' },
  { id: 'writer', label: 'Redattore tecnico' },
  { id: 'security', label: 'Sicurezza' },
  { id: 'notifier', label: 'Notifiche' },
  { id: 'mail-clerk', label: 'Segretario email' },
  { id: 'triage', label: 'Triage' },
  { id: 'data-scientist', label: 'Data scientist' },
  { id: 'devops', label: 'DevOps' },
  { id: 'web-designer', label: 'Web designer' },
  { id: 'ux-ui', label: 'UX/UI designer' },
  { id: 'home', label: 'Domotica' },
  { id: 'translator', label: 'Traduttore' },
  { id: 'scheduler', label: 'Schedulatore' },
];
export const POP_VARIANTS = 5;

/** `developer-02` → l'indirizzo dell'immagine. */
export const popUrl = (avatar: string) => `/pops/pop-${avatar}.webp`;

/** Il ruolo di un avatar: `developer-02` → `developer`. */
export const popRole = (avatar: string) => avatar.replace(/-0\d$/, '');

export const popVariants = (role: string) =>
  Array.from({ length: POP_VARIANTS }, (_, i) => `${role}-0${i + 1}`);

/** Cambia ruolo tenendo il numero della variante: (`developer-02`, `qa`) → `qa-02`. */
export const withRole = (avatar: string | null, role: string) =>
  `${role}-${avatar?.match(/-(0\d)$/)?.[1] ?? '01'}`;
